<li data-test="caTSihnb" class="dropdown__menu-item">
  <a data-test="xG60AO9y" class="dropdown__menu-link">
    <div data-test="m47FPr8-" class="img-block">
      <md-letter-image
        data-test="GBu-05vZ"
        class="img-square"
        [name]="user?.firstName"
        [image]="user?.contactPhotoFilename"
      ></md-letter-image>
      <div data-test="aTFg63Jp" class="img-block__title">
        <b data-test="FozvCWv2">
          {{ user?.firstName + ' ' + user?.lastName }}
        </b>
        <!--<br><span class="text-light text-xsmall">Senior Account Manager</span>-->
      </div>
    </div>
  </a>
</li>
